import slugify from 'slugify'

// ATTENTION sync with gatsby-node.js
export function mySlugifier(s) {
  s = slugify(s, {
    replacement: `-`, // replace spaces with replacement
    remove: /[*+~.()'"!:@]/g, // regex to remove characters
    strict: true,
    lower: true, // result in lower case
  })
  return s
}
// options d'affichage des dates
export const dateOptions = {
  weekday: `short`,
  year: `numeric`,
  month: `long`,
  day: `numeric`,
}

export const partPathFromNode = (node) => {
  node = flattenFileNode(node)
  return `/${node.classe}/${node.matter}/${node.nPart}-${mySlugifier(
    node.part
  )}`
}

export const chapterPathFromNode = (node) => {
  node = flattenFileNode(node)
  return `/${node.classe}/${node.matter}/${node.nPart}-${mySlugifier(
    node.part
  )}/${node.nChapter}-${mySlugifier(node.chapter)}`
}

// aplati les objets recus
// pour eviter les attributs à rallonge
// node.childMArkdownreark.fields.matter => node.matter
// inspiré de https://gist.github.com/penguinboy/762197
export const flattenFileNode = function (fileNode) {
  const toReturn = {}

  for (const key in fileNode) {
    if (!Object.prototype.hasOwnProperty.call(fileNode, key)) continue
    // ATTENTION ne fonctionne pas pour les listes d'objets
    if (Array.isArray(fileNode[key])) {
      toReturn[key] = fileNode[key]
      continue
    }

    if (typeof fileNode[key] === `object`) {
      const flatObject = flattenFileNode(fileNode[key])
      for (const k in flatObject) {
        if (!Object.prototype.hasOwnProperty.call(flatObject, k)) continue

        toReturn[k] = flatObject[k]
      }
    } else {
      toReturn[key] = fileNode[key]
    }
  }
  return toReturn
}

export const matterNameFromMatter = (matter) => {
  switch (matter) {
    // case `nsi`:
    //   return `numérique et sciences informatique`
    case `pc`:
      return `physique-chimie`
    // case `snt`:
    //   return `sciences numériques et technologie`
    case `sci`:
      return `enseignement scientifique`
    default:
      return matter
  }
}

export const matterDescriptionFromMatter = (matter) => {
  switch (matter) {
    case `nsi`:
      return `L’enseignement de spécialité de numérique et sciences informatiques du  cycle  terminal  de  la  voie générale vise l’appropriation des fondements de l’informatique pour préparer les élèves à une poursuite d’études dans l’enseignement supérieur, en les formant à la pratique d’une démarche scientifique et en développant leur appétence pour des activités de recherche.`
    case `pc`:
      return `Dans une société où des informations de tous ordres arrivent dans l’immédiateté et de toutes parts, la priorité est donnée à la formation des esprits pour transformer cette information en une connaissance.`
    case `snt`:
      return `L’enseignement de sciences numériques et technologie en classe de seconde a pour objet de permettre d’appréhender les principaux concepts des sciences numériques, mais également de permettre aux élèves, à partir d’un objet technologique, de comprendre le poids croissant du numérique et les enjeux qui en découlent.`
    case `sci`:
      return `L’ensemble des disciplines scientifiques concourt à la compréhension du monde, de son organisation, de son fonctionnement et des lois qui le régissent, ainsi qu’à la maîtrise des outils et des technologies. L’histoire des sciences raconte une aventure de l’esprit humain, lancé dans une exploration du monde (la science pour savoir) et dans une action sur le monde (la science pour faire).`
    default:
      return `Description`
  }
}

export const classeNameFromClasse = (classe) => {
  switch (classe) {
    case `2gt`:
      return `seconde`
    case `1g`:
      return `première`
    case `tg`:
      return `terminale`
    case `ts`:
      return `terminale S`
    default:
      return classe
  }
}

export const classeWikidataURIFromClasse = (classe) => {
  switch (classe) {
    case `2gt`:
      return `https://www.wikidata.org/wiki/Q3477055`
    case `1g`:
      return `https://www.wikidata.org/wiki/Q3401847`
    case `ts`:
      return `https://www.wikidata.org/wiki/Q3518433`
    case `tg`:
      return `https://www.wikidata.org/wiki/Q3518433`
    default:
      return ``
  }
}
